import { useSelector } from 'react-redux';
import { Modal } from 'antd';
import WarningIcon from '../../assets/image/svg/warning.svg';
import TextBase from '../../common/text';
import { Colors } from '../../themes/Colors';
import { translate } from '../../helper';
import ButtonGradient from '../../common/button-gradient';
import React from 'react';
import LocalStorage from '../../defined/localStorage';
import CloseIcon from '@mui/icons-material/Close';

const brand = JSON.parse(LocalStorage.getItem('branding'));

const TwoFactorAuthModal = ({
    visible,
    width = "calc(var(--fs-hero)*9.5)",
    handleCancel,
    handleOk,
    isEnabling = true,
    loading = false
}) => {
    const whiteLabel = useSelector((state) => state.User?.branding);
    const brandColor = whiteLabel?.web_button_color || brand?.web_button_color || Colors.black;

    return (
        <Modal
            visible={visible}
            footer={<div />}
            centered
            closeIcon={
                <CloseIcon
                    sx={{ fontSize: 'calc(var(--fs-xl)*1.13)' }}
                    onClick={handleCancel}
                />
            }
            width={width}
        >
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginBottom: 'var(--sp-lg)'
                }}
            >
                <img
                    src={WarningIcon}
                    style={{ height: 'calc(var(--fs-xl)*3.5)', width: 'calc(var(--fs-xl)*3.5)' }}
                />
            </div>
            <TextBase
                style={{
                    color: Colors.black,
                    textAlign: 'center',
                    marginBottom: 'var(--sp-md2)'
                }}
                fontWeight={700}
                size={'calc(var(--fs-body) * 1.1)'}
                color={Colors.titlePage}
            >
                {isEnabling ? 'enable2FATitle' : 'disable2FATitle'}
            </TextBase>
            <TextBase
                style={{
                    color: Colors.grey,
                    textAlign: 'center',
                    marginBottom: 'var(--sp-lg)',
                    lineHeight: '1.5'
                }}
                fontWeight={400}
                size={'var(--fs-body)'}
                color={Colors.grey}
            >
                {isEnabling ? 'enable2FADescription' : 'disable2FADescription'}
            </TextBase>
            <div style={{ display: 'flex' }}>
                <ButtonGradient
                    onClick={handleCancel}
                    disabled={loading}
                    textStyle={{
                        fontWeight: 700,
                        fontSize: 'var(--fs-body)',
                        lineHeight: 'var(--sp-lg)',
                        margin: 0,
                        color: Colors.grey
                    }}
                    title={translate('cancel')}
                    iconSize={24}
                    backgroundColor={Colors.white}
                    style={{
                        marginRight: 'var(--sp-md2)',
                        padding: '0px var(--sp-md2)',
                        border: `1px solid ${Colors.grey}`,
                        color: Colors.grey,
                        textTransform: 'uppercase'
                    }}
                />
                <ButtonGradient
                    onClick={handleOk}
                    loading={loading}
                    textStyle={{
                        fontWeight: 700,
                        fontSize: 'var(--fs-body)',
                        lineHeight: 'var(--sp-lg)',
                        margin: 0
                    }}
                    title={translate(isEnabling ? 'enable2FAButton' : 'disable2FAButton')}
                    iconSize={24}
                    backgroundColor={brandColor}
                    style={{
                        marginLeft: 'var(--sp-md2)',
                        textTransform: 'uppercase'
                    }}
                />
            </div>
        </Modal>
    );
};

export default TwoFactorAuthModal;
